import FormModal from "./ConfigurationModal/FormModal";
import PermissionModal from "./ConfigurationModal/PermissionModal";
import RolesModal from "./ConfigurationModal/RolesModal";
import ConfirmationModal from "./ConfimationModal";
import SportModal from "./GameModal/SportModal";

export const modalRegistry = {
  PERMISSION: { component: PermissionModal, isLazy: false },
  CONFIRMATION: { component: ConfirmationModal, isLazy: false },
  FORMMODAL: { component: FormModal, isLazy: false },
  ROLESMODAL: { component: RolesModal, isLazy: false },
  SPORTMODAL: { component: SportModal, isLazy: false },
};
